import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import { Form, Paper } from 'redpoints-front-components';

import { linksManagementClear } from '../../../actions/linksManagementActions';
import { getLinksManagementRelaunchEnforcementErrors } from '../../../reducers/tasks/linksManagement';
import LinksManagementMessages from './LinksManagementMessages';
import LinksManagementRelaunchEnforcementErrors from './LinksManagementRelaunchEnforcementErrors';
import LinksManagementViewer from './LinksManagementViewer';

const LinksManagement = ({
  linksManagementClear,
  relaunchEnforcementErrors,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    return () => {
      linksManagementClear();
    };
  }, [linksManagementClear]);

  const handleCleanLinks = () => {
    form.setFieldsValue({
      [LinkTypeEnum.DETECTION.name]: '',
      [LinkTypeEnum.CONTENT.name]: '',
    });
    linksManagementClear();
  };

  return (
    <Paper>
      <Form name="links-management-form" form={form}>
        <LinksManagementMessages cleanLinks={handleCleanLinks} />
        {relaunchEnforcementErrors === null ? (
          <LinksManagementViewer form={form} />
        ) : (
          <LinksManagementRelaunchEnforcementErrors form={form} />
        )}
      </Form>
    </Paper>
  );
};

const mapStateToProps = state => ({
  relaunchEnforcementErrors: getLinksManagementRelaunchEnforcementErrors(state),
});

export default connect(mapStateToProps, {
  linksManagementClear,
})(LinksManagement);
